/**
 * OptimusAvatar - Reusable avatar component for Optimus
 *
 * Displays the Optimus truck image cropped to focus on the center.
 * Used in chat messages, processing indicators, and welcome screens.
 */

interface OptimusAvatarProps {
  size?: 'sm' | 'md' | 'lg' | 'xl'
  className?: string
}

const sizeClasses = {
  sm: 'w-6 h-6',
  md: 'w-8 h-8',
  lg: 'w-12 h-12',
  xl: 'w-16 h-16',
}

export function OptimusAvatar({
  size = 'md',
  className = '',
}: OptimusAvatarProps) {
  return (
    <div
      className={`${sizeClasses[size]} rounded-full overflow-hidden bg-brand-50 dark:bg-brand-950/30 ring-1 ring-brand-100 dark:ring-brand-900/40 flex-shrink-0 ${className}`}
    >
      <img
        src="/images/chat/optimus-avatar.png"
        alt="Optimus"
        className="w-full h-full object-cover object-[center_25%]"
      />
    </div>
  )
}

export default OptimusAvatar
